import React from 'react';
import Card from '../Card';

import './Metrics.scss';
import { variables } from '../../Tenants';

const Metrics = ({ items, title }) => (
  <Card
    title={title || `${variables.serviceRequest}s`}
    body={(
      <div className="metrics">
        <div className="metrics__items">
          {items.map((i, x) => (
            <div
              key={x}
              className="metrics__item"
            >
              <div className="metrics__value">{i.value}</div>
              <div className="metrics__key">
                {i.key}
              </div>
            </div>
          ))}
        </div>
      </div>
    )}
  />
);

export default Metrics;
